import { isDefined } from "@clipboard-health/util-ts";
import { useToast } from "@src/appV2/lib/Notifications/Toasts/useToast";
import { useHistory, useLocation } from "react-router-dom";

import { PROFILE_FULL_PATH } from "../../Accounts/paths";
import { PageWrapper } from "../../components/PageWrapper";
import { WorkBadgeSelectHeadshot } from "../components/WorkBadgeSelectHeadshot";
import { WorkBadgesReady } from "../components/WorkBadgesReady";
import { useBadgeSmithCheckoutFlag } from "../hooks/useBadgeSmithCheckoutFlag";
import { ProfileWorkBadgesInfo } from "./components/ProfileWorkBadgesInfo";
import { ProfileWorkBadgesSelectRole } from "./components/ProfileWorkBadgesSelectRole";
import { ProfileWorkBadgesStep, useProfileWorkBadges } from "./hooks/useProfileWorkBadges";

export function WorkBadgesProfilePage() {
  const {
    step,
    setStep,
    isLoadingQualifications,
    activeQualifications,
    handleQualificationSelect,
    selectedQualificationId,
    selectedQualification,
    workerHeadshotBase64,
    setWorkerHeadshotBase64,
    imageSource,
    setImageSource,
  } = useProfileWorkBadges();

  const badgeSmithCheckout = useBadgeSmithCheckoutFlag();

  const history = useHistory();
  const location = useLocation();
  const { showErrorToast } = useToast();

  return (
    <PageWrapper variant="tertiary">
      {step === ProfileWorkBadgesStep.INFO && (
        <ProfileWorkBadgesInfo
          isLoading={isLoadingQualifications}
          onGetStarted={() => {
            if (activeQualifications.length === 0) {
              showErrorToast("You don't have any roles yet. Please add a role first.");
              return;
            }

            setStep(ProfileWorkBadgesStep.SELECT_ROLE);
          }}
        />
      )}

      {step === ProfileWorkBadgesStep.SELECT_ROLE && (
        <ProfileWorkBadgesSelectRole
          activeQualifications={activeQualifications}
          selectedQualificationId={selectedQualificationId}
          handleQualificationSelect={handleQualificationSelect}
          onContinue={() => {
            setStep(ProfileWorkBadgesStep.SELECT_HEADSHOT);
          }}
          onBack={() => {
            setStep(ProfileWorkBadgesStep.INFO);
          }}
        />
      )}

      {step === ProfileWorkBadgesStep.SELECT_HEADSHOT && isDefined(selectedQualification) && (
        <WorkBadgeSelectHeadshot
          qualificationName={selectedQualification.qualification.attributes.displayLabel}
          onConfirm={({ workerHeadshotBase64, imageSource }) => {
            setWorkerHeadshotBase64(workerHeadshotBase64);
            setImageSource(imageSource);
            setStep(ProfileWorkBadgesStep.BADGE_READY);
          }}
          onBack={() => {
            setStep(ProfileWorkBadgesStep.SELECT_ROLE);
          }}
        />
      )}

      {step === ProfileWorkBadgesStep.BADGE_READY &&
        isDefined(selectedQualification) &&
        isDefined(workerHeadshotBase64) && (
          <WorkBadgesReady
            qualificationName={selectedQualification.qualification.attributes.displayLabel}
            emailSuccessModal={{
              primaryButtonText: "Go back to Profile",
              onPrimaryButtonClick: () => {
                if (isDefined(location.key)) {
                  history.goBack();
                } else {
                  history.replace(PROFILE_FULL_PATH);
                }
              },
            }}
            workerHeadshotBase64={workerHeadshotBase64}
            imageSource={imageSource}
            badgeSmithCheckout={
              badgeSmithCheckout.enabled
                ? { checkoutUrl: badgeSmithCheckout.checkoutUrl }
                : undefined
            }
            onBack={() => {
              setStep(ProfileWorkBadgesStep.SELECT_HEADSHOT);
            }}
          />
        )}
    </PageWrapper>
  );
}
